module.exports = __webpack_public_path__ + "location_dark.54b310b1444cfcebc588.svg";


//////////////////
// WEBPACK FOOTER
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/assets/modules/dummy-assets/common/img/icon/svg_icon/location_dark.svg
// module id = ../../../../../src/assets/modules/dummy-assets/common/img/icon/svg_icon/location_dark.svg
// module chunks = styles